/* eslint-disable jsx-a11y/label-has-for */
import React, { PureComponent } from 'react';
import CheckIcon from 'mdi-react/CheckIcon';
import CloseIcon from 'mdi-react/CloseIcon';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const CheckBox = ({
    defaultChecked = false,
    disabled = false,
    className = '',
    name = '',
    value = false,
    onChange = () => {},
    label = '',
    color = '',
}) => {
    // useEffect(() => {}, []);

    const CheckboxClass = classNames({
        'checkbox-btn': true,
        disabled,
    });

    return (
        <label
            className={`${CheckboxClass} ${
                className ? ` checkbox-btn--${className}` : ''
            }`}
            htmlFor={name}
        >
            <input
                className='checkbox-btn__checkbox'
                type='checkbox'
                id={name}
                name={name}
                onChange={onChange}
                checked={!!value}
                disabled={disabled}
            />
            <span
                className='checkbox-btn__checkbox-custom'
                style={
                    color
                        ? { background: color, borderColor: color }
                        : { marginTop: '2px' }
                }
            >
                <CheckIcon />
            </span>
            {className === 'button' ? (
                <span className='checkbox-btn__label-svg'>
                    <CheckIcon className='checkbox-btn__label-check' />
                    <CloseIcon className='checkbox-btn__label-uncheck' />
                </span>
            ) : (
                ''
            )}
            <span className='checkbox-btn__label'>{label}</span>
        </label>
    );
};
